import { Fragment } from "react";
import { Divider } from "react-native-paper";
import type { ScoreRange } from "../../types";
import Box from "../Box";
import TopicListHeader from "./TopicListHeader";
import TopicListItem from "./TopicListItem";
import type { SortByDataType, SortOrderType, TopicNode } from "./types";

type TopicViewMainContentProps = {
	onSortPress: () => void;
	tags: TopicNode[];
	selectedSortByItem?: SortByDataType;
	selectedSortOrder: SortOrderType;
	title: string;
	scoreRanges?: ScoreRange[];
};

const TopicViewMainContent = ({
	onSortPress,
	tags,
	selectedSortByItem,
	selectedSortOrder,
	title,
	scoreRanges,
}: TopicViewMainContentProps) => {
	const numTags = tags.length;
	return (
		<Box>
			<TopicListHeader
				title={title}
				onSortPress={onSortPress}
				numTags={numTags}
				selectedSortByItem={selectedSortByItem}
				selectedSortOrder={selectedSortOrder}
			/>
			<Box flexGrow={1}>
				{tags.map((tag, index) => (
					<Fragment key={`${tag.id}-${index}`}>
						<TopicListItem
							{...tag}
							numItems={tag.numItems}
							title={
								tag.code
									? `${tag.code} - ${tag.label || tag.title || ""}`
									: tag.label || tag.title || ""
							}
							subTopics={tag.children}
							scoreRanges={scoreRanges}
						/>
						{index !== tags.length - 1 && <Divider />}
					</Fragment>
				))}
			</Box>
		</Box>
	);
};

export default TopicViewMainContent;
